import React, { useState } from 'react';

function MessageQuestion({ data }) {
    return (
      <>
        <h1>{data.title}</h1>
        <p>{data.message}</p>
      </>
    );
}

function OpenQuestion({ data }) {
    const [response, setResponse] = useState('');

  const handleInputChange = (e) => {
    setResponse(e.target.value);
    global.onAns(data.key, e.target.value, true)
  };

  return (
    <div className="open-question">
      <h2>{data.question}</h2>
      <p>{data.helpTxt}</p>
      <input 
        type="text" 
        value={response} 
        onChange={handleInputChange} 
        placeholder={data.placeholder}
      />
      {/* Include any other elements like a submit button if needed */}
    </div>
  );
}

function CloseQuestion({ data }) {
    // Assuming data is the question object like the one provided
    const { question, options, key } = data;
  
    return (
      <div className="close-question">
        <h2>{question}</h2>
        <ul>
          {options.map((option, index) => (
            <li key={`${question.key}-${option.key}`}>
              <button onClick={e => {
                e.target.classList.add('button-clicked'); 
                global.onAns(key, option.key)
              }}>{option.txt}</button>
            </li>
          ))}
        </ul>
      </div>
    );
  }

// In Question.js
function Question({ loading, img, data, onNavigate, currentIndex, totalQuestions }) {
    const renderQuestion = () => {
        switch (data.type) {
          case 'message':
            return <MessageQuestion data={data} />;
          case 'open_question':
            return <OpenQuestion data={data} />;
          case 'close_question':
            return <CloseQuestion data={data} />;
          default:
            return null;
        }
      };
    const isLastQuestion = currentIndex === totalQuestions - 1;
  
    return (
      <div className="question-container">
        <div className="image-placeholder">
            <img src={img} alt="Image Placeholder" style={{borderRadius: 16}} className={loading ? "animated-image" : ""} />
        </div> 
        <div className={loading ? "question-content animated-opc" : "question-content"}>
            {renderQuestion()}
          {/* Render options if type is 'close_question' */}
        </div>
        <div className="button-container" style={{opacity: loading ? 0.2 : 1}}>
            {!data.hideBack && <button onClick={() => onNavigate('prev')} style={{opacity: currentIndex === 0 ? 0 : 1}}>חזור</button>}
            {data.nextBtnTxt && <button onClick={() => onNavigate('next')}>{data.nextBtnTxt}</button>}
        </div>
      </div>
    );
  }
  
  export default Question;
  
  